<template>
  <Breadcrumbs
      title="Edit Route"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Routes', path: '/routes' },
      { label: 'Edit Route', path: `/edit-route?routeId=${routeId}` },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editRouteForm :routeId="routeId"/>
    </div>
  </div>
</template>

<script>

import editRouteForm from "@/pages/master_data/routes/editRouteForm.vue";

export default {
  components: {
    editRouteForm
  },
  computed: {
    routeId() {
      return this.$route.query.routeId;
    }
  }
}
</script>